angular.module('home', [])
    .controller('homeController', ['$scope', '$location', 'authenticationInfo', function ($scope, $location, authenticationInfo) {
        $scope.authentication = authenticationInfo;

        //Para cuando se accede a la aplicación y se mantiene la autenticación de una sesión anterior
        if ($scope.authentication.isAuthenticated) {
            $location.path('/login2FA');
        };
    }]);